module.exports = __webpack_public_path__ + "img/intro1.bcb6309a.png";